const PREFIX = "ginrummy";

export function getItem (key: string) {
    return window.localStorage.getItem(`${PREFIX}${key}`);
}

export function setItem (key: string, value: any) {
    return window.localStorage.setItem(`${PREFIX}${key}`, value);
}


export function removeItem (key: string) {
    return window.localStorage.removeItem(`${PREFIX}${key}`);
}



// WEBPACK FOOTER //
// ./src/core/storage.ts